export default __webpack_public_path__ + "static/media/MOVR.bf671da5.png";